export { routerReducer } from '@ngrx/router-store';

export const routerFeatureKey = 'router';
